<template>
  <v-list class="py-0">
    <template v-for="item in getItems">
      <v-list-group no-action :key="item.id"
        append-icon="fal fa-angle-down"
        :class="['px-0', { 'red lighten-4': item.status === 'locked' }]"
        :data-id="item.id">
        <template v-slot:activator>
          <v-list-item-content class="py-0">
            <v-row>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.date }}</v-col>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.client }}</v-col>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.label }}</v-col>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.item }}</v-col>
              <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.sum }}</v-col>
            </v-row>
          </v-list-item-content>
        </template>
        <v-list-item v-for="jtem in item.children" :key="jtem.id">
          <v-list-item-avatar>
            <v-icon small>{{ jtem.cbook.flag === 'T' ? 'fa-lock' : 'fa-check' }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-0">
            <v-list-item-subtitle>{{ `${jtem.client}：${jtem.cbook.title}：${$props.meta.type[jtem.type] || ''}：${$props.meta.items[jtem.label] || ''}` }}</v-list-item-subtitle>
            <v-list-item-title>{{ jtem.sum }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-divider :key="`${item.id}_div`"></v-divider>
    </template>
    <v-list-item v-if="getItems.length === 0">
      <v-list-item-content>
        <v-list-item-title class="text-center">登録されている項目はありません</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'authorBbookRemoveDc',
  props: [ 'items', 'meta' ],
  data () {
    return {
    }
  },
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        return {
          id: it.id,
          date: this.$moment(it.date).format('YYYY/MM/DD'),
          client: it.client,
          label: it.label,
          item: it.item,
          sum: it.sum,
          status: it.status,
          children: it.children
        }
      }) : []
    }
  }
}
</script>